import {
  GRID_COL_INDEX_ATTRIBUTE,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { CSSProperties, FunctionComponent } from "react";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import s from "./Cells.module.scss";
import classNames from "classnames";
import { DisplayItem } from "@iliotech/watchlist-api";

interface IOwnProps {
  gridCellProps: GridCellProps;
  cell: FunctionComponent<any>;
  field: any;
  rightAligned?: boolean;
  removeBorderLeft?: boolean;
  dataItem?: any;
  extraStyles?: CSSProperties;
  onClick?: (id: DisplayItem) => void;
}
export const CellWrapper = ({
  gridCellProps,
  cell,
  rightAligned,
  removeBorderLeft,
  dataItem,
  extraStyles,
  field,
  onClick,
}: IOwnProps) => {
  const Cell = cell;
  const index = gridCellProps.dataItem.id;
  const navigationAttributes = useTableKeyboardNavigation(gridCellProps.id);

  return (
    <td
      style={{
        // TODO: replace colors with appropriate css-vars
        color: "var(--color)",
        backgroundColor: "transparent",
        ...extraStyles,
        ...gridCellProps.style,
      }}
      colSpan={gridCellProps.colSpan}
      role={"gridcell"}
      className={classNames(
        gridCellProps.className,
        s.tableCell,
        rightAligned && s.rightAligned,
        removeBorderLeft && s.removeBorderLeft
      )}
      aria-colindex={gridCellProps.ariaColumnIndex}
      aria-selected={gridCellProps.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: gridCellProps.columnIndex,
      }}
      {...navigationAttributes}
    >
      <Cell index={index} dataItem={dataItem} field={field} onClick={onClick} />
    </td>
  );
};
